import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-d81de41c")
const _hoisted_1 = { style: {"margin-top":"10px"} }
const _hoisted_2 = { class: "upload_opt_btn" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 开始上传 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 清空 ")
_popScopeId()

import { computed, ref } from 'vue'
import { uploadFileToOss } from '@/utils/oss'
import { message } from 'ant-design-vue'
import { UploadOutlined } from '@ant-design/icons-vue'


export default {
  props: {
  value: {
    type: Object,
    default: () => {
      return {}
    }
  },
  accept: {
    type: String,
    default: () => '.mp3,.wav,.ogg,.aac,.m4a'
  },
  aliasConfig: {
    type: Object,
    default: () => {
      return {
        url: 'file_url',
        name: 'file_name',
        md5: 'file_md5',
        size: 'file_size'
      }
    }
  }
},
  emits: ['ok'],
  setup(__props, { emit }) {

const props = __props




const valueComputed = computed(() => props.value)
const currentFile = ref(null)

const fileList = ref([])
const fileName = ref('')

const loading = ref(false)

const uploadPrecent = ref(0)
const uploadStatus = ref('normal')

const handleBeforeUpload = file => {
  currentFile.value = file
  fileName.value = file.name
  uploadPrecent.value = 0
  uploadStatus.value = 'normal'
  handleUpload()
  return false
}

const onPrecentChange = (precent) => {
  uploadPrecent.value = precent
}

const handleUpload = async () => {
  if (currentFile.value) {
    try {
      loading.value = true
      uploadStatus.value = 'normal'
      const data = await uploadFileToOss(currentFile.value, true, onPrecentChange)
      const fileInfo = {
        [props.aliasConfig.name]: data.name.substring(0, data.name.lastIndexOf('.')),
        [props.aliasConfig.url]: data.url,
        [props.aliasConfig.md5]: data.md5,
        [props.aliasConfig.size]: data.size
      }
      uploadStatus.value = 'success'
      message.success('上传成功')
      loading.value = false
      emit('ok', fileInfo)
    } catch (error) {
      loading.value = false
      console.log(error)
      uploadStatus.value = 'exception'
      message.error('上传失败，请重试')
    }
  }
}

const handleCleanAll = () => {
  currentFile.value = null
  fileList.value = []
  fileName.value = ''
  uploadPrecent.value = 0
  uploadStatus.value = 'normal'
  loading.value = false
  const info = {
    [props.aliasConfig.name]: '',
    [props.aliasConfig.url]: undefined,
    [props.aliasConfig.md5]: undefined
  }
  emit('ok', info)
}


return (_ctx, _cache) => {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_progress = _resolveComponent("a-progress")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload, {
      name: "song_file",
      "file-list": null,
      multiple: false,
      accept: props.accept,
      "before-upload": handleBeforeUpload
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, { disabled: loading.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(UploadOutlined)),
            _createTextVNode(_toDisplayString(currentFile.value === null ? "选择文件" : "重选文件"), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["accept"]),
    _createElementVNode("span", _hoisted_1, _toDisplayString(fileName.value), 1),
    (uploadPrecent.value > 0)
      ? (_openBlock(), _createBlock(_component_a_progress, {
          key: 0,
          percent: uploadPrecent.value,
          status: uploadStatus.value
        }, null, 8, ["percent", "status"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: handleUpload,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, {
        class: "clean_btn",
        type: "primary",
        danger: "",
        onClick: handleCleanAll,
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

}